<template>

  <div class="help-panels">

    <v-expansion-panels tile>

      <v-expansion-panel>
        <v-expansion-panel-header>
         {{ $t('helpContents.marketplace.whatIsMarketplace.title') }}
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div v-html="$t('helpContents.marketplace.whatIsMarketplace.contents')"></div>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header>
          {{ $t('helpContents.marketplace.howToAddTradingPair.title') }}
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div v-html="$t('helpContents.marketplace.howToAddTradingPair.contents')"></div>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header>
          {{ $t('helpContents.marketplace.howToReadOrders.title') }}
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div v-html="$t('helpContents.marketplace.howToReadOrders.contents')"></div>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header>
          {{ $t('helpContents.marketplace.howToTrade.title') }}
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div v-html="$t('helpContents.marketplace.howToTrade.contents')"></div>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header>
         {{ $t('helpContents.marketplace.isPartialFillPossible.title') }}
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div v-html="$t('helpContents.marketplace.isPartialFillPossible.contents')"></div>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header>
         {{ $t('helpContents.marketplace.feeForCreateOrder.title') }}
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div v-html="$t('helpContents.marketplace.feeForCreateOrder.contents')"></div>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header>
         {{ $t('helpContents.marketplace.feeForFillOrder.title') }}
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div v-html="$t('helpContents.marketplace.feeForFillOrder.contents')"></div>
        </v-expansion-panel-content>
      </v-expansion-panel>

    </v-expansion-panels>


  </div>


</template>

<script>

export default {
  name: 'MarketplaceHelp',
  props: {
  },
  data () {
    return {
    }
  },
}
</script>


<style scoped>

</style>
